module.exports = __webpack_public_path__ + "img/icon_shibai@2x.d8caf0f1.png";